/**
 * 提交验证警告组件
 * 显示提交前的验证问题，如缺少明细的事务
 */

import { Alert, Space, Tag } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useBatchTransactionContext } from "../context/BatchTransactionContext";

const SubmitValidationAlert = () => {
    const { state, transactionManager } = useBatchTransactionContext();

    const missingDetailsTransactionIds = transactionManager.getTransactionsMissingDetails();
    const hasValidationIssues = !transactionManager.canSubmit() && missingDetailsTransactionIds.length > 0;

    if (!hasValidationIssues) {
        return null;
    }

    // 获取缺少明细的事务信息
    const missingDetailsTransactions = state.transactions.filter((t) => missingDetailsTransactionIds.includes(t.id));

    return (
        <Alert
            type="warning"
            showIcon
            icon={<ExclamationCircleOutlined />}
            message="提交前检查"
            description={
                <div>
                    <div style={{ marginBottom: 8 }}>以下航班的事务缺少明细（产品），无法提交：</div>
                    <Space wrap>
                        {missingDetailsTransactions.map((transaction) => (
                            <Tag key={transaction.id} color="red">
                                {transaction.flightNumber || `事务${transaction.id}`}
                            </Tag>
                        ))}
                    </Space>
                    <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>请为每个航班的事务添加至少一条明细（产品）后再提交</div>
                </div>
            }
            style={{ marginBottom: 16 }}
        />
    );
};

export default SubmitValidationAlert;
